/**
 * Generates the full name to be displayed into address components
 * @param firstName first name of address info
 * @param middleName middle name of address info
 * @param lastName last name of address info
 * @returns string with new format
 */
export const getDisplayName = (firstName, middleName, lastName) => {
    const spacingForLastName = !!firstName || !!middleName ? ' ' : '';
    const spacingForMiddleName = firstName ? ' ' : '';
    const firstNameDisplay = firstName ?? '';
    const middleNameDisplay = middleName
        ? `${spacingForMiddleName}${middleName}`
        : '';
    const lastNameDisplay = lastName ? `${spacingForLastName}${lastName}` : '';
    return `${firstNameDisplay}${middleNameDisplay}${lastNameDisplay}`;
};
